import { TranslateModule } from '@ngx-translate/core';
import { NgModule } from '@angular/core';


import { ThemeModule } from '../../@theme/theme.module';
import { TacheComponent } from './tache.component';
import { TacheListComponent } from './tache-list/tache-list.component';
import { TacheItemComponent } from './tache-list/tache-item/tache-item.component';
@NgModule({
  imports: [
    ThemeModule,
    TranslateModule,
  ],
  declarations: [
    TacheComponent,
    TacheListComponent,
    TacheItemComponent,
  ],
})
export class TacheModule {

}
